import React, { Component } from 'react';
import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

// Compontents
import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';
import Firebase, { FirebaseContext, initFB } from './Components/Firebase';

// Pages
import Home from './Pages/Home/Home';
import Project from './Pages/ProjectDetails/ProjectDetails';

class App extends Component {
  componentDidMount() {
    initFB();
  }

  render() {
    return (
      //  <Home />
      <FirebaseContext.Provider>
        <BrowserRouter>
          <Switch>
            <Route path='/' exact component={Home} />
            <Route path='/project/:id' exact component={Project} />
            <Route component={Home} />
          </Switch>
        </BrowserRouter>
        <Footer />
      </FirebaseContext.Provider>
    );
  }
}

export default App;
